<template>
    <div class="input-datepicker">
        <flat-pickr v-model="val" :config="conf" :name="name"></flat-pickr>
        <label class="input-datepicker__label"></label>
    </div>
</template>

<script>
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/themes/dark.css';
import { Vietnamese } from 'flatpickr/dist/l10n/vn.js';

export default {
    name: 'InputDatepicker',
    props: {
        name: String,
        date: {
            type: String,
            required: false,
            default: () => new Date(),
        },
        config: {
            type: Object,
            required: false,
            default: () => ({
                dateFormat: 'd-m-Y',
            }),
        },
    },
    computed: {
        val: {
            get() {
                return this.date;
            },
            set(newValue) {
                this.$emit('change', newValue);
            },
        },
        conf: {
            get() {
                return {
                    ...this.config,
                    ...{ onChange: this.onChange, locale: Vietnamese },
                };
            },
        },
    },
    model: {
        prop: 'date',
        event: 'change',
    },
    methods: {
        onChange(selectedDates, dateStr) {
            this.$emit('onChange', { selectedDates, dateStr });
        },
    },
    components: {
        FlatPickr,
    },
};
</script>
